import { useState } from 'react';

import { Option } from 'types';

const usePagination = (
  pageOptions: number[],
  pageIndex: number,
  pageSize: number,
  previousPage: () => void,
  nextPage: () => void
) => {
  const [currentPage, currentPageSet] = useState<Option>();

  const sortingSizes = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];
  const sortingSizesMapped = sortingSizes.map((size) => ({ value: size, label: size }));
  const pageOptionsMapped = pageOptions.map((page) => ({
    value: page,
    label: page + 1,
  }));
  const defaultPage = { value: pageIndex, label: pageIndex + 1 };
  const defaultSortingSize = { value: pageSize, label: pageSize };

  const setPreviousPage = () => {
    previousPage();

    if (currentPage) {
      currentPageSet({
        value: Number(currentPage?.value) - 1,
        label: Number(currentPage?.label) - 1,
      });
    } else {
      currentPageSet({
        value: defaultPage.value - 1,
        label: defaultPage.label - 1,
      });
    }
  };

  const setNextPage = () => {
    nextPage();

    if (currentPage) {
      currentPageSet({
        value: Number(currentPage?.value) + 1,
        label: Number(currentPage?.label) + 1,
      });
    } else {
      currentPageSet({
        value: defaultPage.value + 1,
        label: defaultPage.label + 1,
      });
    }
  };

  return {
    currentPage,
    currentPageSet,
    sortingSizesMapped,
    pageOptionsMapped,
    defaultSortingSize,
    setPreviousPage,
    setNextPage,
    defaultPage,
  };
};

export { usePagination };
